@if (seasonData | async; as item) {
  <div>
    <div class="col-12" id="orders_topcontent">
      <div class="row">
        <div class="col-9 col-md-3 col-lg-2 right_border" id="orders_topcontentleftcontent">
          <h1 class="col-xs-12 orders_titeltop modified-h1">{{"allinvoice.title" | cxTranslate}}</h1>
        </div>
        <div class="col-3  col-md-4 col-lg-6  no-dis" id="orders_topcontentleftcontent">
          <div class="col-xs-12 orders_titeltop orders_titeltopNo" >{{getCount()}}</div>
        </div>
        <div class="col-12 col-md-5 col-lg-4" id="orders_topcontentleftcontent">
          <div class="invoice_us_dropdown">
            <select  (change)="selectedSeason($event)" class="current_sesson_dropdown" name="session" id="select_season" [(ngModel)]="finalSeason">
              @for (obj of item.seqirusSeasonList; track obj; let i = $index) {
                <option  [value]="obj" > {{(obj == item.preSeason)?'Pre-Book Season': ( (obj!= item.inSeason)?'Previous Season': 'Current Season')}}: {{obj}} </option>
              }
            </select>
          </div>
        </div>
      </div>
    </div>
    <!-- count of sch payments -->
    @if (getScheduledPaymentCount() > 0) {
      <div class="sch_pay_linksection">
        <div class="sch_Pay_Container"><span class="schpay_linktext">You have {{getScheduledPaymentCount()}} <a class="all_inv_schpaylink" routerLink="/scheduled-payments">Scheduled Payment(s)</a></span></div>
      </div>
    }
  </div>
}
